type Properties = {
    coachId: string;
    messageId: string;
};

const CoachError = (props: Properties) => {
    return (
        <p className="error" data-testid="coacherror-paragraph">
            <b>Fehler:</b> CoachMessage <b>{props.messageId}</b> existiert nicht oder hat für Coach <b>{props.coachId}</b> keine Message.
        </p>);
};

export default CoachError;
